&nbsp;<a role="button" tabindex="0" class="btn p-0 fa fa-info-circle text-decoration-none cursor-pointer" data-toggle="popover"
    [attr.data-content]="tooltipContent" [attr.aria-expanded]="isTooltipOpen()" (click)="getTooltipContent()" (keydown)="keyBoardActivate($event)"
    [attr.data-analytics]="analyticData">
    <span class="sr-only">{{screenReaderText}}</span>
</a>